import { render } from "./InformacoesFornecedor.vue?vue&type=template&id=98d3c446"
import script from "./InformacoesFornecedor.vue?vue&type=script&lang=js"
export * from "./InformacoesFornecedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__